<div class="filter-section" [formGroup]="unitForm">
  <div class="overlap-toggle">
    <span>{{ (name | langtranslate ) | uppercase}}</span>
    <div class="toggle">
        <input type="checkbox" id="mode-toggle_ttm" class="toggle__input" [checked]="trailing12"
            (change)="onToggleChange($event)">
        <label for="mode-toggle_ttm" class="toggle__label"></label>
    </div>
    <span>{{('reports.ttm' | translate) | uppercase}}</span>
    <span *ngIf="required" class="required">*</span>
</div>
  <label class="datepicker-label"></label>
  <div class="date-range-input">
    <div  (click)="startPicker.open()"  class="filter-date-input form-control" style="direction: ltr" >
      <input [disabled]="!trailing12"  [placeholder]="'Choose Start Date' | translate" matInput [matDatepicker]="startPicker" [min]="minStartDate"
       name = "startDate" [(ngModel)]="startDate" [ngModelOptions]="{standalone: true}" (dateChange)="onStartEndDateChange(startDate, endDate)"  readonly/>
      <mat-datepicker-toggle matSuffix [for]="startPicker" ></mat-datepicker-toggle>
      <mat-datepicker  #startPicker></mat-datepicker>
    </div>
    <div (click)="endPicker.open()" class="filter-date-input form-control" style="direction: ltr" >
      <input [disabled]="!trailing12"  [placeholder]="'Choose End Date' | translate" matInput [matDatepicker]="endPicker" [min]="minStartDate"
      [(ngModel)]="endDate" name="endDate" [ngModelOptions]="{standalone: true}"
      [matDatepickerFilter]="endDateFilter" (dateChange)="onStartEndDateChange(startDate, endDate)" readonly/>
      <mat-datepicker-toggle matSuffix [for]="endPicker"></mat-datepicker-toggle>
      <mat-datepicker #endPicker></mat-datepicker>
    </div>
  </div>
</div>
